
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"36","viewBox":"0 0 35 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1426_14295)","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M17.5 0v29.167M11.667 29.167L17.5 35l5.833-5.833"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1426_14295"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h35v36H0z"}})])])])
          )
        }
      }
    